export const PENDIENTE = 1;
export const CERRADO = 2;